import {PagewebErrorType} from '../../errors/PagewebErrorType.enum';
import {CustomApolloError} from './CustomApolloError';

/**
 * Api 호출은 성공했으나 response가 없는 케이스를 처리하는 Simple 에러를 생성합니다.
 * 단순 방어 로직 용도로 사용합니다.
 */
export function createSimpleApiResponseError(message: string) {
  return new CustomApolloError({
    isSerializedPagewebError: true,
    message,
    type: PagewebErrorType.ApiResponseFailError,
  });
}
